<template>
	<div class="sidebar"  >
			<nav class="sidenav-dashboard">  
              <div class="logo">
              <img id="fwlogo" src="../assets/fwlogo.svg" align="middle" >
              <img id="fwname" src="../assets/freshworks.svg"  align="middle" >
              </div>
              <div class="user" style="line-height: 45px;">
              <img src="../assets/user.svg" id="photo" align="middle" >
              <span id="user" style="margin-left:10px;">{{ username }}</span>
              </div>
              <ul class="nav">
              <li class="nav-item"><router-link v-bind:class="[ activetab === 1 ? 'active' : '' ]" tag="a" to="/dashboard" key="link_dashboard">
              <img src="../assets/dashboardimg.svg" style="width:25px;height:25px;margin-left:20px;">
              <span id="name">Dashboard</span>
              </router-link></li>
              <li class="nav-item"><router-link  tag="a" v-bind:class="[ activetab === 2 ? 'active' : '' ]" to="/stacks" key="link_stackusage">
              <img src="../assets/aws-seeklogo.com.svg" style="width:25px;height:25px;margin-left:20px;">
              <span id="name">Stacks</span>
              </router-link></li>
              <li class="nav-item"><router-link  tag="a" v-bind:class="[ activetab === 3 ? 'active' : '' ]" to="/teams" key="link_stackandteam">
              <img src="../assets/team.svg" style="width:25px;height:25px;margin-left:20px;">
              <span id="name">Team</span>
              </router-link></li>
            </ul>  
        </nav>      
    </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
export default {
	name:'SideNavBar',
	  data() {
	    return {
	      username:'',
        activetab:1
	    };
	  },
    mounted() {
      
    },
	  created() {
	    this.username=this.$session.get("username");
	  },
	  methods:{
		    /*refresh(){
		    	this.activetab=this.getactivetab;
		    }*/
	  },
    computed: {
      ...mapGetters([
      'getactivetab'
      ])
    },
    watch: {
      getactivetab: function(){
        this.activetab=this.getactivetab
      }
    }
}
</script>
<style>
#photo{
  width: 37px;
    height: 43px;
    overflow: hidden;
    float: left;
    margin-right: 0%;
    margin-left: 35px;
    z-index: 5;
}
.sidebar {
  background-image: linear-gradient(
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.5)
    ),url("../assets/background-image.jpg");
  position: fixed;
  top:0px;
  bottom:0px;
  left:0px;
  width: 260px;
  margin: 0px;
  display:block;
  background-position-x: 50%;
  background-position-y: center;
  background-size: cover;
  z-index: 1;
  color: #fff;
  font-weight: 200;
}
.sidebar .sidenav-dashboard{
    position: relative;
    max-height: calc(100vh - 75px);
    min-height: 100%;
    overflow: auto;
    width: 260px;
    z-index: 4;
    padding-bottom: 100px;
    touch-action: auto;
    overflow: hidden!important;
}
.sidebar .sidenav-dashboard .logo {
    padding: 12px 0 9px;
    margin: 0;
    position: relative;
    z-index: 4;
    display: block;
    box-sizing: border-box;
    border-bottom: 1px solid hsla(0,0%,100%,.2);
    height:70px;
}
#fwlogo{
    width: 30px;
    display: inline-block;
    height: 32px;
    line-height: 45px;
    margin-left:35px;
}

.sidebar .sidenav-dashboard .logo #fwname{
  display: inline-block;
  margin-left:10px;
  height:50px;
}

.sidebar .sidenav-dashboard .user{
  padding: 12px 0 9px;
    margin: 0;
    position: relative;
    z-index: 4;
    display: block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-bottom: 1px solid hsla(0,0%,100%,.2);
    height: 70px;
}
.sidebar .sidenav-dashboard .nav{
    
    margin-top:15px;
    float: none;
    display: block;
    flex-wrap: wrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style-type: none;
    list-style-position: initial;
    list-style-image: initial;
}
.sidebar .sidenav-dashboard .nav .nav-item  {
      color: #fff;
    opacity: .86;
    border-radius: 4px;
    text-transform: uppercase;
    line-height: 45px;
    font-size: 12px;
    font-weight: 600;
        padding-left: 5px;
    padding-right: 0px;
    white-space: nowrap;
}
.sidebar .sidenav-dashboard .nav .nav-item a{
	text-decoration: none;
	display:block;
	border-radius: 4px;
	margin: 5px 15px 0 10px;
	color:#fff;
}
.sidebar .sidenav-dashboard .nav .nav-item a img{
	padding:0 5px 0 0;
	vertical-align: middle;
}

.sidebar .sidenav-dashboard .nav .nav-item a span{
	display: inline-block;
  vertical-align: middle;
  line-height: normal;
  padding: 10px;
}
.sidebar .sidenav-dashboard .nav .nav-item a:hover{
	color: #fff;
    opacity: .50;
	background: hsla(0,0%,100%,.23); 
	margin: 5px 15px 0 10px;  
}
.sidebar .sidenav-dashboard .nav .nav-item a.active{
	color: #fff;
    opacity: 1;
	background: hsla(0,0%,100%,.23);   
}
.sidebar .sidenav-dashboard active {
  background-color: #00ccf1;
  color: white;
  border-radius: 5px;
}
@media only screen and (max-width: 1325px) {
  #name{
    opacity: 0;
  }
  .sidebar{
    width: 80px;
  }
  .sidebar:hover {
    width: 260px;
  }
  #user{
  display:none;
  }
    #fwname{
  visibility:hidden;
  }
}
</style>